export var UPDATE_ASSIGNMENT_ACCESS_USE_CASE = 'UPDATE_ASSIGNMENT_ACCESS_USE_CASE';